export default __webpack_public_path__ + "static/media/fresno-stacked.617974a5.png";